<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [advanceButton]="true"
                [advancedButtons]="specialButton"
                (outputButtonAdvance)="calFunction($event)"
                [title]="'global.overview'|translate">
        <app-grid [buttonViewChange]="false" [grid]="grid" (sendParameters)="setParams($event)"></app-grid>
      </app-card>
    </div>
  </div>
</div>
<ng-template #customerPriceTemp let-row="row" let-value="value" let-column="column">
  <span *ngIf="row.isCredit">- </span>{{row.amount | CustomCurrency}}
</ng-template>
<a #downloadLink href="" download style="display: none"></a>
<ng-template #statusTemplate let-row="row" let-value="value" let-column="column">
  {{ ('doctrine.backoffice.invoice.statuses.' + (value === 'credit_invoice' || value === 'overdue' ? 'open' : value )) | translate}}
  {{ (value == 'partial_paid' ? ' (' + (row.partialPaid | BackofficeCurrency) + ')' : '') }}
</ng-template>
<ng-template #typeTemplate let-row="row" let-value="value" let-column="column">
  {{ ('doctrine.invoice.types.' + (row.isCredit ? 'credit' : 'invoice')) | translate}}
</ng-template>
<ng-template #dueDateTemplate let-row="row" let-value="value">
  <div class="due-date-container">
    <span class="date">
      {{ !value ? '-' : formatDateString(value) }}
    </span>
    <ng-container *ngIf="row.status === 'overdue'">
      <span class="status-text">
        {{ 'doctrine.backoffice.invoice.statuses.overdue' | translate }}
        ({{ calculateOverdueDays(row.dueDate) }} days)
      </span>
    </ng-container>
  </div>
</ng-template>
